import { render, staticRenderFns } from "./commentDeclaration.vue?vue&type=template&id=7f961b4c&scoped=true&"
import script from "./commentDeclaration.vue?vue&type=script&lang=js&"
export * from "./commentDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./commentDeclaration.vue?vue&type=style&index=0&id=7f961b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f961b4c",
  null
  
)

export default component.exports